import { render } from "./dialogPedido.vue?vue&type=template&id=5bd3d1b5&scoped=true"
import script from "./dialogPedido.vue?vue&type=script&lang=js"
export * from "./dialogPedido.vue?vue&type=script&lang=js"

import "./dialogPedido.vue?vue&type=style&index=0&id=5bd3d1b5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd3d1b5"]])

export default __exports__